export default __webpack_public_path__ + "static/media/CallIcon.16d8ff95.svg";